import DraggablePopup from './DraggablePopup';
import styles from './EditorTrial.module.css';

interface editorTrialProps {
    onClose: () => void;
}

function EditorTrial({ onClose }: editorTrialProps) {
    
    return (
        <div className={styles.resizable_popup}>
            <DraggablePopup title="Debug Information" onClose={onClose}>
                <div className={styles.scrollable_content}>
                </div>
            </DraggablePopup>
        </div>
    );
}

export default EditorTrial